import { Collapse, Modal, Table } from 'antd';
import { useEvent, useStore, useUnit } from 'effector-react';
import { Column } from '@ant-design/charts';
import {
  $clusterInfoModal,
  $clusterNiche,
  $modalAltTitle,
  resetClusterInfoModalEv,
} from '../../models/overviewModel/index.js';
import style from './ClusterInfoModal.module.css';
import bahrain from '../../assets/business_model_flags/bahrain.png';
import china from '../../assets/business_model_flags/china.png';
import kuwait from '../../assets/business_model_flags/kuwait.png';
import oman from '../../assets/business_model_flags/oman.png';
import uae from '../../assets/business_model_flags/uae.png';
import uzbekistan from '../../assets/business_model_flags/uzbekistan.png';
import strategy_1 from '../../assets/business_models_icons/strategy_1.png';
import strategy_2 from '../../assets/business_models_icons/strategy_2.png';
import strategy_3 from '../../assets/business_models_icons/strategy_3.png';
import strategy_4 from '../../assets/business_models_icons/strategy_4.png';
import strategy_5 from '../../assets/business_models_icons/strategy_5.png';
import strategy_6 from '../../assets/business_models_icons/strategy_6.png';
import airport_block from '../../assets/cluster_icons/airport_block.png';
import meat_block from '../../assets/cluster_icons/meat_block.png';
import sheep_block from '../../assets/cluster_icons/sheep_block.png';
import tribal_block from '../../assets/cluster_icons/tribal_block.png';
import airport_legend from '../../assets/cluster_icons/airport_legend.png';
import meat_legend from '../../assets/cluster_icons/meat_legend.png';
import sheep_legend from '../../assets/cluster_icons/sheep_legend.png';
import tribal_legend from '../../assets/cluster_icons/tribal_legend.png';
import ClusterMap from './ClusterMap.jsx';
import ClusterGmkContent from './ClusterGmkContent.jsx';

const directors_board_data = {
  data: [
    {
      num: 1,
      name: 'Баталов Раимбек Анварович',
      company: 'Председатель Президиума НПП «Атамекен»',
    },
    {
      num: 2,
      name: 'Карагойшин Рустам Тимурович',
      company: 'Председатель Правления АО «НУХ «Байтерек»',
    },
    {
      num: 3,
      name: 'Егембердиев Берик Елубаевич',
      company: 'Директор ТОО «Мерке – Ет Комбинаты» ',
    },
    {
      num: 4,
      name: 'Оспанов Бауржан Кенесбекович',
      company: 'Председатель Наблюдательного Совета ',
    },
    {
      num: 5,
      name: 'Мукашев Ерлан Кумарович',
      company: 'Президент «Eurasia RED»',
    },
    {
      num: 6,
      name: 'Тажнияз Нурканат',
      company: 'Руководитель ТОО «АФ «Бірлік»',
    },
    {
      num: 7,
      name: 'Омашев Кайырлы Бейсенович ',
      company:
        'Исполнительный директор Республиканской палаты «Овец грубошерстного направления продуктивности» (Жетысуская область)',
    },
    {
      num: 8,
      name: 'Ертаев Сырым Махамбетович',
      company: 'Генеральный директор ТОО «Қайып ата» (Туркестанская)',
    },
  ],
  columns: [
    {
      title: '№',
      dataIndex: 'num',
      key: 'db_num',
    },
    {
      title: 'Ф.И.О.',
      dataIndex: 'name',
      key: 'db_name',
    },
    {
      title: 'Компания',
      dataIndex: 'company',
      key: 'db_company',
    },
  ],
};

const indicators_bullets_data = {
  economical_indicators: [
    {
      category: 'Объем экспорта баранины в общем производстве, %',
      type: 'План',
      value: 30,
    },
    {
      category: 'Объем экспорта баранины в общем производстве, %',
      type: 'Факт',
      value: 5,
    },
    {
      category: 'Рентабельность продукции, %',
      type: 'План',
      value: 30,
    },
    {
      category: 'Рентабельность продукции, %',
      type: 'Факт',
      value: 10,
    },
    {
      category: 'Средняя экспортная цена – цена за 1 кг мяса, $',
      type: 'План',
      value: 10,
    },
    {
      category: 'Средняя экспортная цена – цена за 1 кг мяса, $',
      type: 'Факт',
      value: 6.5,
    },
  ],
  industry_indicators: [
    {
      category: 'Рост поголовье овец, шт.',
      type: 'План',
      value: 50,
    },
    {
      category: 'Рост поголовье овец, шт.',
      type: 'Факт',
      value: 18,
    },
    {
      category: 'Убойный выход мяса, кг',
      type: 'План',
      value: 20,
    },
    {
      category: 'Убойный выход мяса, кг',
      type: 'Факт',
      value: 13,
    },
    {
      category: 'Доля племенного маточного стада, %',
      type: 'План',
      value: 20,
    },
    {
      category: 'Доля племенного маточного стада, %',
      type: 'Факт',
      value: 3,
    },
  ],
  transfer_technologies: [
    {
      category:
        'Применение искусственного осеменения и трансплантации эмбрионов для ускоренного улучшения породы',
      type: 'План',
      value: 2,
    },
    {
      category:
        'Применение искусственного осеменения и трансплантации эмбрионов для ускоренного улучшения породы',
      type: 'Факт',
      value: 0,
    },
    {
      category: 'Использование Австралийской ротационной системы выпаса',
      type: 'План',
      value: 5,
    },
    {
      category: 'Использование Австралийской ротационной системы выпаса',
      type: 'Факт',
      value: 0,
    },
    {
      category: 'Автоматизированные бойни и мясокомбинаты',
      type: 'План',
      value: 2,
    },
    {
      category: 'Автоматизированные бойни и мясокомбинаты',
      type: 'Факт',
      value: 0,
    },
  ],
};

const top_problems_columns = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'top_problems_id',
  },
  {
    title: 'Наименование',
    dataIndex: 'name',
    key: 'top_problems_name',
  },
  {
    title: 'Проблемность',
    dataIndex: 'level',
    key: 'top_problems_level',
  },
  {
    title: 'Статус решения (отклонено ГО, на рассмотрении ГО, решен)',
    dataIndex: 'status',
    key: 'top_problems_status',
    render: (status, record) => {
      if (status === 'На рассмотрении ГО') {
        return (
          <div
            className={style.problem_status}
            style={{ background: '#ffc000' }}
          >
            {status}
          </div>
        );
      }
      if (status === 'Отклонено ГО') {
        return (
          <div
            className={style.problem_status}
            style={{ background: '#ff7c80' }}
          >
            {status}
          </div>
        );
      }
      if (status === 'Решен') {
        return (
          <div
            className={style.problem_status}
            style={{ background: '#00b050' }}
          >
            {status}
          </div>
        );
      }
    },
  },
  {
    title: 'Таймлайн',
    key: 'top_problems_timeline',
    children: [
      {
        title: 'Дата регистрации в системе',
        dataIndex: 'registration_date',
        key: 'top_problems_registration_date',
      },
      {
        title: 'Дата планируемного решения',
        dataIndex: 'plan_date',
        key: 'top_problems_plan_date',
      },
      {
        title: 'Дата фактического решения (если есть)',
        dataIndex: 'fact_date',
        key: 'top_problems_fact_date',
      },
    ],
  },
  {
    title: 'Ответственный орган',
    dataIndex: 'responsible',
    key: 'top_problems_responsible',
  },
  {
    title: 'Принятые меры',
    dataIndex: 'measures',
    key: 'top_problems_measures',
  },
  {
    title: 'Предлагаемое решения',
    dataIndex: 'solution',
    key: 'top_problems_solution',
  },
  {
    title: 'Прикрепить файл',
    dataIndex: 'file',
    key: 'top_problems_file',
  },
];

const top_problems_current_data = [
  {
    id: '1',
    name: 'Потрава пастбищных угодий сайгаками',
    level: 'Высокая',
    status: 'На рассмотрении ГО',
    registration_date: '10.04.2025',
    plan_date: '25.08.2025',
    fact_date: '',
    responsible: 'МЭПР РК',
    measures: '',
    solution: '',
  },
  {
    id: '2',
    name: 'Упрощение процедуры получения субсидий на строительства колодцев для обводнение пастбищ',
    level: 'Высокая',
    status: 'На рассмотрении ГО',
    registration_date: '1.02.2024',
    plan_date: '31.12.2025',
    fact_date: '',
    responsible: 'МСХ РК',
    measures: '',
    solution: '',
  },
];

const top_problems_systemic_data = [
  {
    id: '1',
    name: 'Отсутствие актуальных данных о качественных характеристиках пастбищ',
    level: 'Высокая',
    status: 'На рассмотрении ГО',
    registration_date: '1.03.2024',
    plan_date: '8.08.2025',
    fact_date: '',
    responsible: 'МСХ РК',
    measures: '',
    solution: '',
  },
  {
    id: '2',
    name: 'Логистические барьеры экспорта в Катар',
    level: 'Высокая',
    status: 'Решен',
    registration_date: '29.03.2025',
    plan_date: '10.04.2025',
    fact_date: '8.04.2025',
    responsible: 'МТ',
    measures: '',
    solution: '',
  },
  {
    id: '3',
    name: 'Отсутствие согласованных ветеринарных требований к охлажденному мясу и субпродуктам МРС',
    level: 'Высокая',
    status: 'На рассмотрении ГО',
    registration_date: '1.03.2024',
    plan_date: '10.10.2025',
    fact_date: '',
    responsible: 'МСХ',
    measures: '',
    solution: '',
  },
];

const project_team_columns = [
  {
    title: '№',
    key: 'project_team_id',
    dataIndex: 'id',
  },
  {
    title: 'Ф.И.О.',
    key: 'project_team_full_name',
    dataIndex: 'full_name',
  },
  {
    title: 'Компания',
    key: 'project_team_company',
    dataIndex: 'company',
  },
];

const project_team_data = [
  {
    id: '1',
    full_name: 'Егембердиев Берик Елубаевич',
    company: 'Директор ТОО «Мерке – Ет Комбинаты»',
  },
  {
    id: '2',
    full_name: 'Бердалин Амангалий Бисенбаевич',
    company: 'Вице-министр сельского хозяйства РК',
  },
  {
    id: '3',
    full_name: 'Шоканов Нурсултан Нурланович',
    company: 'Заместитель Председателя Правления НПП РК «Атамекен»',
  },
  {
    id: '4',
    full_name: 'Шайхы Жандос Алкенович',
    company: 'Заместитель Председателя Правления АО «НУХ «Байтерек»',
  },
  {
    id: '5',
    full_name: 'Оспанов Бауржан Кенесбекович',
    company: 'Председатель Наблюдательного Совета ТОО «ИПК ZHERSU»',
  },
  {
    id: '6',
    full_name: 'Мукашев Ерлан Кумарович',
    company: 'Президент «Eurasia RED»',
  },
  {
    id: '7',
    full_name: 'Баталов Аскар Болатович',
    company: 'Учредитель ТОО «АФ «Бірлік»',
  },
  {
    id: '8',
    full_name: 'Омашев Кайырлы Бейсенович',
    company:
      'Исполнительный директор Республиканской палаты «Овец грубошерстного направления продуктивности»',
  },
  {
    id: '9',
    full_name: 'Кенжебаев Жанибек Болатович',
    company: 'Директор ТОО «Евразия-инвест»',
  },
  {
    id: '10',
    full_name: 'Ахметов Ернур Нуртасович',
    company: 'Координатор стратегии НПП РК «Атамекен»',
  },
];

const business_model_product = [
  'Охлажденное мясо баранины',
  'Замороженное мясо баранины',
  'Субпродукты',
  'Колбасные изделия и консервы',
];

const business_model_resources = [
  'Земельные и природные (Пастбища, Водные ресурсы, Оросительные системы)',
  'Генетические и биологические (Лаборатории, Племенные овцы высокопродуктивных пород)',
  'Трудовые ресурсы (Ветеринары, зоотехники, агрономы)',
  'Финансовые (Банковские кредиты и лизинг, субсидий)',
  'Инфраструктурные (инженерные инфраструктура, транспорт и складирование)',
];

const business_model_sales_market_columns = [
  {
    title: 'Рынок',
    key: 'bm_market',
    dataIndex: 'market',
    render: (market, record) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div>{market}</div>
          <img src={record.flag} style={{ width: 100, height: 50 }} />
        </div>
      );
    },
  },
  {
    title: 'Объем, тонна',
    key: 'bm_volume',
    dataIndex: 'volume',
  },
  {
    title: 'Стоимость, кг',
    key: 'cost',
    dataIndex: 'cost',
    render: (cost) => `${cost} $/кг`,
  },
];

const business_model_sales_market_data = [
  {
    market: 'Узбекистан',
    volume: '100 000',
    cost: '6.5',
    flag: uzbekistan,
  },
  {
    market: 'ОАЭ',
    volume: '50 000',
    cost: '3.2',
    flag: uae,
  },
  {
    market: 'Кувейт',
    volume: '20 000',
    cost: '8.5',
    flag: kuwait,
  },
  {
    market: 'Оман',
    volume: '20 000',
    cost: '6.9',
    flag: oman,
  },
  {
    market: 'Бахрейн',
    volume: '20 000',
    cost: '8,2',
    flag: bahrain,
  },
  {
    market: 'КНР',
    volume: '350 000',
    cost: '8,2',
    flag: china,
  },
];

const business_model_strategy_data = [
  {
    icon: strategy_1,
    text: 'Создание кооперации',
  },
  {
    icon: strategy_2,
    text: 'Улучшение породы маточного стада Организация селекционной генетической работы ',
  },
  {
    icon: strategy_3,
    text: 'Организация высокопродуктивны хозяйств с интенсивным/полуинтенсивным методом производства  ',
  },
  {
    icon: strategy_4,
    text: 'Кормовая база:',
    bullets: [
      'Развитие кормовых культур с помощью оросительной системой',
      'Заготовка гранулированных кормов ',
    ],
  },
  {
    icon: strategy_5,
    text: 'Организация типовых откорм площадок',
  },
  {
    icon: strategy_6,
    text: 'Организация убойных цехов и цехов глубокой переработки',
  },
];

const target_indicators_economical_table = [
  {
    key: 'industrial-header',
    name: 'Производственные',
    isHeader: true,
  },
  {
    key: 'industrial-1',
    name: 'Количество поголовья, в млн голов',
    fact24: 18.6,
    plan30: 45,
  },
  {
    key: 'industrial-2',
    name: 'Коэффициент приплода, в единицах',
    fact24: 0.65,
    plan30: 1.2,
  },
  {
    key: 'industrial-3',
    name: 'Доля маточного поголовья, в %',
    fact24: 3,
    plan30: 20,
  },
  {
    key: 'industrial-4',
    name: 'Суточный привес, в граммах',
    fact24: 90,
    plan30: 250,
  },
  {
    key: 'industrial-5',
    name: 'Убойный выход мяса, в кг',
    fact24: 15,
    plan30: 20,
  },
  {
    key: 'economical-header',
    name: 'Экономические',
    isHeader: true,
  },
  {
    key: 'economical-1',
    name: 'Средняя экспортная цена, в долларах США',
    fact24: 7.5,
    plan30: 15,
  },
  {
    key: 'economical-2',
    name: 'Средняя внутренняя цена, в долларах США',
    fact24: 6,
    plan30: 6,
  },
  {
    key: 'economical-3',
    name: 'Внтуренний объем потребления, в тыс.тонн',
    fact24: 115,
    plan30: 150,
  },
  {
    key: 'economical-4',
    name: 'Объем экспорта, в тыс.тонн',
    fact24: 17.2,
    plan30: 100,
  },
  {
    key: 'economical-5',
    name: 'Объем инвестиций, в млрд. тенге',
    fact24: 10,
    plan30: 100,
  },
  {
    key: 'economical-6',
    name: 'Объем инвестиций на 1 голову, в долларах США',
    fact24: 100,
    plan30: 800,
  },
  {
    key: 'economical-7',
    name: 'Рабочие места, в тыс. чел.',
    fact24: null,
    plan30: null,
  },
  {
    key: 'economical-8',
    name: 'Налоги, млн. тенге',
    fact24: null,
    plan30: null,
  },
];

function ClusterInfoModal() {
  const clusterInfoModal = useStore($clusterInfoModal);
  const close = useEvent(resetClusterInfoModalEv);
  const clusterNiche = useStore($clusterNiche);
  const altTitle = useUnit($modalAltTitle);

  const content = (
    <>
      {clusterInfoModal === 'target_indicators' && <TargetIndicators />}
      {/* {clusterInfoModal === 'business_model' && */}
      {/*  business_model_data.map((item, index) => { */}
      {/*    if (item.type === 'list') { */}
      {/*      return ( */}
      {/*        <div key={`bm-${index}`}> */}
      {/*          <div className={style.modal_info_title}>{item.title}</div> */}
      {/*          <ul> */}
      {/*            {item.children.map((child, childIndex) => { */}
      {/*              return ( */}
      {/*                <li key={`bm-child-${index}-${childIndex}`}>{child}</li> */}
      {/*              ); */}
      {/*            })} */}
      {/*          </ul> */}
      {/*        </div> */}
      {/*      ); */}
      {/*    } */}
      {/*    return ( */}
      {/*      <div key={`bm-${index}`} className={style.modal_info_text_wrapper}> */}
      {/*        <div className={style.modal_info_title}>{item.title}</div> */}
      {/*        <div>{item.text}</div> */}
      {/*      </div> */}
      {/*    ); */}
      {/*  })} */}
      {clusterInfoModal === 'directors_board' && (
        <Table
          dataSource={directors_board_data.data}
          columns={directors_board_data.columns}
          pagination={false}
        />
      )}
      {clusterInfoModal === 'economical_indicators' ||
      clusterInfoModal === 'industry_indicators' ||
      clusterInfoModal === 'transfer_technologies' ? (
        <Column
          xField="category"
          yField="value"
          data={indicators_bullets_data[clusterInfoModal]}
          seriesField="type"
          isGroup
          tooltip={{
            formatter: (data) => {
              let { value } = data;
              if (
                data.category === 'Рентабельность продукции, %' &&
                data.type === 'Факт'
              ) {
                value = '0-10';
              }
              if (
                data.category === 'Убойный выход мяса, кг' &&
                data.type === 'Факт'
              ) {
                value = '10-13';
              }
              return {
                name: data.type,
                value: `${value} ${
                  data.category.includes(',')
                    ? data.category.split(', ')[1]
                    : ''
                }`,
              };
            },
          }}
        />
      ) : (
        ''
      )}
      {clusterInfoModal === 'top_problems' ? (
        <div
          style={{
            marginRight: 20,
          }}
        >
          <Collapse
            defaultActiveKey={['Current']}
            items={[
              {
                key: 'Current',
                label: 'Текущие',
                children: (
                  <Table
                    pagination={false}
                    columns={top_problems_columns}
                    dataSource={top_problems_current_data}
                  />
                ),
              },
              {
                key: 'Systemic',
                label: 'Системные',
                children: (
                  <Table
                    pagination={false}
                    columns={top_problems_columns}
                    dataSource={top_problems_systemic_data}
                  />
                ),
              },
            ]}
          />
        </div>
      ) : (
        ''
      )}
      {clusterInfoModal === 'project_team' ? (
        <Table
          style={{
            marginRight: 20,
          }}
          columns={project_team_columns}
          dataSource={project_team_data}
          pagination={false}
        />
      ) : null}
      {clusterInfoModal === 'business_model' ? (
        <Collapse
          style={{
            marginRight: 20,
          }}
          defaultActiveKey="product"
          items={[
            {
              key: 'product',
              label: 'Продукт',
              children: (
                <ol>
                  {business_model_product.map((item, index) => {
                    return <li key={`product-${index}`}>{item}</li>;
                  })}
                </ol>
              ),
            },
            {
              key: 'resources',
              label: 'Ресурсы',
              children: (
                <ol>
                  {business_model_resources.map((item, index) => {
                    return <li key={`product-${index}`}>{item}</li>;
                  })}
                </ol>
              ),
            },
            {
              key: 'sales_market',
              label: 'Рынок сбыта',
              children: (
                <Table
                  columns={business_model_sales_market_columns}
                  dataSource={business_model_sales_market_data}
                  pagination={false}
                />
              ),
            },
            {
              key: 'regions',
              label: 'Регионы',
              children: (
                <div>
                  <div style={{ height: 600, position: 'relative' }}>
                    <ClusterMap />
                    <div className={style.regions_legend}>
                      <div className={style.regions_legend_item}>
                        <img src={airport_legend} />
                        Грузовые склады аэропортов оборудованные холодильными
                        камерами
                      </div>
                      <div className={style.regions_legend_item}>
                        <img src={sheep_legend} />
                        Поголовье овец (млн. голов)
                      </div>
                      <div className={style.regions_legend_item}>
                        <img src={meat_legend} />
                        Мясоперерабатывающие комплексы (ед)
                      </div>
                      <div className={style.regions_legend_item}>
                        <img src={tribal_legend} />
                        Племенные центры (ед)
                      </div>
                    </div>
                  </div>
                  <div className={style.regions_block_wrapper}>
                    <div className={style.regions_block}>
                      <img
                        src={airport_block}
                        className={style.regions_block_img}
                      />
                      <div className={style.regions_block_text}>
                        4 Аэропорта имеют инфраструктуру для экспорта мяса
                        (Астана, Алматы, Актау, Караганда)
                      </div>
                    </div>
                    <div className={style.regions_block}>
                      <img
                        src={sheep_block}
                        className={style.regions_block_img}
                      />
                      <div className={style.regions_block_text}>
                        Поголовье овец:
                        <div>
                          <label className={style.red_text}>58,9%</label>
                          на юге
                        </div>
                        <div>
                          <label className={style.red_text}>11,6%</label>
                          на западе
                        </div>
                      </div>
                    </div>
                    <div className={style.regions_block}>
                      <img
                        src={meat_block}
                        className={style.regions_block_img}
                      />
                      <div className={style.regions_block_text}>
                        <label className={style.red_text}>42</label> МПК по убою
                        МРС
                      </div>
                    </div>
                    <div className={style.regions_block}>
                      <img
                        src={tribal_block}
                        className={style.regions_block_img}
                      />
                      <div className={style.regions_block_text}>
                        <label className={style.red_text}>7</label>
                        племенных центров
                      </div>
                    </div>
                  </div>
                </div>
              ),
            },
            {
              key: 'strategy',
              label: 'Стратегия',
              children: (
                <ul>
                  {business_model_strategy_data.map((item, index) => {
                    return (
                      <div
                        key={`strategy-${index}`}
                        className={style.strategy_item}
                      >
                        <img src={item.icon} />
                        <div>
                          <div>{item.text}</div>
                          {item.bullets ? (
                            <ol>
                              {item.bullets.map((bullet, bulletIndex) => {
                                return (
                                  <li key={`bullet-${bulletIndex}`}>
                                    {bullet}
                                  </li>
                                );
                              })}
                            </ol>
                          ) : null}
                        </div>
                      </div>
                    );
                  })}
                </ul>
              ),
            },
          ]}
        />
      ) : null}
    </>
  );

  return (
    <Modal
      open={!!clusterInfoModal}
      onCancel={close}
      footer={null}
      // FIXME HON
      width="60dvw"
      title={
        altTitle
          ? altTitle
          : clusterInfoModal === 'target_indicators' && clusterNiche === 'gmk'
          ? 'Ключевые показатели'
          : clusterInfoModal === 'project_team'
          ? 'Проектная команда'
          : null
      }
    >
      {clusterNiche === 'ГМК' ? (
        <ClusterGmkContent clusterInfoModal={clusterInfoModal} />
      ) : (
        content
      )}
    </Modal>
  );
}

export default ClusterInfoModal;

function TargetIndicators(props) {
  const columns = [
    {
      title: 'Целевые индикаторы',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        // Check if this is a section header row
        if (record.isHeader) {
          return {
            children: <strong>{text}</strong>,
            props: {
              colSpan: 3,
              style: {
                backgroundColor: '#1e3a5f',
                color: 'white',
                textAlign: 'center',
                fontWeight: 'bold',
              },
            },
          };
        }
        return text;
      },
    },
    {
      title: 'Факт (2024)',
      dataIndex: 'fact24',
      key: 'fact24',
      align: 'center',
      render: (text, record) => {
        if (record.isHeader) {
          return {
            props: {
              colSpan: 0,
            },
          };
        }
        return text;
      },
    },
    {
      title: 'План (2030)',
      dataIndex: 'plan30',
      key: 'plan30',
      align: 'center',
      render: (text, record) => {
        if (record.isHeader) {
          return {
            props: {
              colSpan: 0,
            },
          };
        }
        return text;
      },
    },
  ];

  return (
    <div>
      <div className={style.target_indicators_content}>
        <Table
          columns={columns}
          pagination={false}
          dataSource={target_indicators_economical_table}
          style={{ width: '100%' }}
          bordered
        />
        {/*{(indicators === 'economical'*/}
        {/*  ? target_indicators_economical*/}
        {/*  : target_indicators_industrial*/}
        {/*).map((item, index) => {*/}
        {/*  return (*/}
        {/*    <div*/}
        {/*      key={`indicator-${index}`}*/}
        {/*      className={style.target_indicators_card}*/}
        {/*    >*/}
        {/*      <div style={{ textAlign: 'center' }}>{item.title}</div>*/}
        {/*      <TargetIndicatorsProgress {...item} />*/}
        {/*    </div>*/}
        {/*  );*/}
        {/*})}*/}
      </div>
    </div>
  );
}

function TargetIndicatorsProgress(props) {
  const { points, active, total, bar_color, line_color, measure } = props;
  return (
    <div
      className={style.target_indicators_progress_bar}
      style={{
        background: bar_color,
      }}
    >
      <div className={style.target_indicators_progress_plan}>План</div>
      <div
        className={style.target_indicators_progress_line}
        style={{
          width: `calc(${active !== 0 ? (active * 100) / total : 7.5}% - 10px)`,
          background: line_color,
        }}
      >
        Факт
      </div>
      {points.map((item, index) => {
        return (
          <div
            key={`${item.plan}-${item.year}-${index}`}
            className={style.target_indicators_progress_point}
            style={{
              left: `${
                active !== 0
                  ? (item.plan * 100) / total
                  : (item.plan * 100) / total + 7.5
              }%`,
            }}
          >
            <div
              style={{
                transform: 'translateX(-20%)',
              }}
            >
              {`${item.plan} ${measure}`}
            </div>
            <div className={style.target_indicators_progress_point_line} />
            <div
              className={style.target_indicators_progress_point_label}
              style={{
                transform: 'translateX(-50%)',
              }}
            >
              {item.year}
            </div>
          </div>
        );
      })}
    </div>
  );
}
